import { Skeleton, Stack, Table, type MantineSize } from '@mantine/core';

type SkeletonWidth = number | string;

export interface TableSkeletonProps {
  rows?: number;
  columns: number | SkeletonWidth[];
  height?: number;
}

export function TableSkeleton({ rows = 8, columns, height = 14 }: TableSkeletonProps) {
  const widths = typeof columns === 'number' ? Array.from({ length: columns }, () => '75%') : columns;

  return Array.from({ length: rows }, (_, rowIndex) => (
    <Table.Tr key={rowIndex}>
      {widths.map((width, columnIndex) => (
        <Table.Td key={columnIndex}>
          <Skeleton height={height} radius="sm" width={width} />
        </Table.Td>
      ))}
    </Table.Tr>
  ));
}

export interface DetailSkeletonProps {
  lines?: number;
  gap?: MantineSize;
}

export function DetailSkeleton({ lines = 8, gap = 'sm' }: DetailSkeletonProps) {
  return (
    <Stack gap={gap} aria-label="Carregando dados">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton
          key={index}
          height={16}
          radius="sm"
          width={index % 3 === 2 ? '62%' : index % 2 === 0 ? '88%' : '74%'}
        />
      ))}
    </Stack>
  );
}
